import React from 'react';

import PropTypes from 'prop-types';
import NavigationPrompt from 'react-router-navigation-prompt';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';

import Button from '@material-ui/core/Button';

import { isEqual } from 'lodash';

class FormNavConfirm extends React.Component {
  // constructor(props) {
  //     super(props);
  // }

  componentDidMount() {}

  render() {
    let { formObject, pristineObject } = this.props;
    const showPrompt = !isEqual(formObject, pristineObject);

    return (
      <NavigationPrompt
        // beforeConfirm={(clb)=>this.cleanup(clb)} //call the callback function when finished cleaning up
        // Children will be rendered even if props.when is falsey and isActive is false:
        // renderIfNotActive={true}
        // Confirm navigation if going to a path that does not start with current path:
        // allowGoBack={true}
        when={(crntLocation, nextLocation) => {
          // console.log({crntLocation, nextLocation});
          // return !nextLocation || !nextLocation.pathname.startsWith(crntLocation.pathname)
          return showPrompt;
        }}
      >
        {({ isActive, onCancel, onConfirm }) => {
          if (isActive) {
            return (
              <Dialog aria-labelledby="confirmation-dialog-title" open={isActive}>
                <DialogTitle id="confirmation-dialog-title">Leave Page</DialogTitle>
                <DialogContent>
                  There are unsaved changes on this page. Are you sure you would like to leave?
                </DialogContent>
                <DialogActions>
                  <Button onClick={onCancel} variant="outlined" color="primary">
                    Cancel
                  </Button>
                  <Button onClick={onConfirm} variant="contained" color="primary">
                    Ok
                  </Button>
                </DialogActions>
              </Dialog>
            );
          }
          return <div>This is probably an anti-pattern but ya know...</div>;
        }}
      </NavigationPrompt>
    );
  }
}

FormNavConfirm.propTypes = {
  formObject: PropTypes.object.isRequired,
  pristineObject: PropTypes.object.isRequired,
};

export default FormNavConfirm;
